import orderBy from 'lodash/orderBy';

import { Action } from '@/_core/fluxstore/types';
import { NotificationsState, UserNotificationModel, UserNotificationReply } from '../types';
import { useNotificationsStore } from '../useModule';
import { NotificationsQueryResult } from '@/api/notifications/queries';
import { mapArrayDtoPropsToCamelCase } from '@/_core/utils/mapDtos';

const { registerReducer } = useNotificationsStore();

export class InitNotifications extends Action<NotificationsState> {
    public static ACTION_TYPE = 'InitNotifications';
    public constructor(public res: NotificationsQueryResult) {
        super(InitNotifications.ACTION_TYPE);
    }
}

const reducer = (state: NotificationsState, action: InitNotifications): void => {
    state.storymapsWhereCommentingEnabled = action.res.StorymapsWhereCommentingEnabled;

    const mappedNotifications = mapArrayDtoPropsToCamelCase(action.res.Notifications);

    const notifications = orderBy(mappedNotifications, 'happenedAt', 'desc');

    state.allNotifications = notifications.map((item: UserNotificationModel) => {
        const userNotificationModel = new UserNotificationModel();

        const replies = item.replies.map((reply) => {
            return new UserNotificationReply(reply.CommentText, reply.CommentedAt);
        });

        item.replies = replies;

        Object.assign(userNotificationModel, item);

        return userNotificationModel;
    });

    state.storymapUrlTemplate = action.res.StorymapUrlTemplate;

    state.isInitialized = true;
};

//@ts-ignore
registerReducer(InitNotifications.ACTION_TYPE, reducer);
